import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import UserModule from "./modules/user.module";
import AuthModule from "./modules/auth.module";
import OrderFormModule from "./modules/orderForm.module";
import MasterModule from "./modules/master.module";
import UiModule from "./modules/ui.module";
import ConfigModule from "./modules/config.module";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    user: UserModule,
    auth: AuthModule,
    orderForm: OrderFormModule,
    master: MasterModule,
    ui: UiModule,
    config: ConfigModule,
  },
  mutations: {},
  actions: {},
});
